<template>

    <div v-if="visible" class="toast-container">
        <div class="toast" :class="type">
            <svg v-if="type == 'info'" class="left" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-615, -3295)" fill="#51A200" fill-rule="nonzero">
                        <g transform="translate(600, 3280)">
                            <path d="M25,15 C30.52275,15 35,19.47725 35,25 C35,30.52275 30.52275,35 25,35 C19.47725,35 15,30.52275 15,25 C15,19.47725 19.47725,15 25,15 Z M29.28,21.96925 C29.1392446,21.8286697 28.948404,21.7497694 28.7494696,21.7499099 C28.5505353,21.7500508 28.3598064,21.8292207 28.21925,21.97 L23.756,26.44 L21.77925,24.4715 C21.4851219,24.1831375 21.0134789,24.1859442 20.7228034,24.4777867 C20.432128,24.7696293 20.4312113,25.2412797 20.72075,25.53425 L23.22825,28.0315 C23.5214812,28.3235394 23.9958465,28.3228682 24.28825,28.03 L29.28075,23.03 C29.4213303,22.8892446 29.5002306,22.6984041 29.5000901,22.4994697 C29.4999492,22.3005353 29.4207792,22.1098064 29.28,21.96925 L29.28,21.96925 Z" id="形状"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <svg v-else-if="type == 'warning'" class="left" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-615, -3365)" fill="#FF2F25" fill-rule="nonzero">
                        <g transform="translate(600, 3350)">
                            <path d="M25,15 C26.3779528,15 27.6706037,15.2591864 28.8779528,15.7775591 C30.0853018,16.2959318 31.148294,17.0144357 32.0669291,17.9330709 C32.9855643,18.851706 33.7040682,19.9146982 34.2224409,21.1220472 C34.7408136,22.3293963 35,23.6220472 35,25 C35,26.3648294 34.7375328,27.6509186 34.2125984,28.8582677 C33.687664,30.0656168 32.9625984,31.1286089 32.0374016,32.0472441 C31.1122047,32.9658793 30.0459318,33.687664 28.8385827,34.2125984 C27.6312336,34.7375328 26.351706,35 25,35 C23.6351706,35 22.3490814,34.7408136 21.1417323,34.2224409 C19.9343832,33.7040682 18.8713911,32.9855643 17.9527559,32.0669291 C17.0341207,31.148294 16.312336,30.0853018 15.7874016,28.8779528 C15.2624672,27.6706037 15,26.3779528 15,25 C15,23.6220472 15.2624672,22.3326772 15.7874016,21.1318898 C16.312336,19.9311024 17.0341207,18.8681102 17.9527559,17.9429134 C18.8713911,17.0177165 19.9343832,16.2959318 21.1417323,15.7775591 C22.3490814,15.2591864 23.6351706,15 25,15 Z M24.980315,28.0511811 C24.5341207,28.0511811 24.1469816,28.2152231 23.8188976,28.5433071 C23.4908136,28.8713911 23.3267717,29.2650919 23.3267717,29.7244094 C23.3267717,30.183727 23.4908136,30.574147 23.8188976,30.8956693 C24.1469816,31.2171916 24.5341207,31.3779528 24.980315,31.3779528 C25.4396325,31.3779528 25.8333333,31.2171916 26.1614173,30.8956693 C26.4895013,30.574147 26.6535433,30.183727 26.6535433,29.7244094 C26.6535433,29.2782152 26.4927822,28.8877953 26.1712598,28.5531496 C25.8497375,28.2185039 25.4527559,28.0511811 24.980315,28.0511811 Z M25,18.5629921 C24.5800525,18.5629921 24.2454068,18.687664 23.996063,18.9370079 C23.7467192,19.1863517 23.6286089,19.5144357 23.6417323,19.9212598 L23.7992126,25.5511811 C23.812336,25.8792651 23.9271654,26.1515748 24.1437008,26.3681102 C24.3602362,26.5846457 24.6456693,26.6929134 25,26.6929134 C25.3412073,26.6929134 25.6200787,26.5846457 25.8366142,26.3681102 C26.0531496,26.1515748 26.167979,25.8792651 26.1811024,25.5511811 L26.3385827,19.9212598 C26.351706,19.5144357 26.2335958,19.1863517 25.984252,18.9370079 C25.7349081,18.687664 25.4068241,18.5629921 25,18.5629921 Z" id="形状结合"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <div>{{ msg }}</div>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="right" @click="cancle">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-1432.000000, -192.000000)">
                        <g transform="translate(464.000000, 176.000000)">
                            <g transform="translate(968.000000, 16.000000)">
                                <path d="M1.70672494,0.292723696 L4.99972153,3.58472034 L8.29271811,0.292723696 C8.47495796,0.110683835 8.72041429,0.00597966695 8.97793995,0.000449974937 C9.23547561,-0.00508971651 9.4852017,0.0889550454 9.67510112,0.262995352 C9.86499054,0.437035658 9.98040411,0.677642257 9.99729317,0.934677941 C10.0141722,1.19170362 9.93122685,1.4453395 9.76572607,1.6427185 C9.76572607,1.6427185 9.74605717,1.66405398 9.70671936,1.70672494 L6.41472271,4.99972153 L9.70671936,8.29271811 C9.88875922,8.47495796 9.99346339,8.72041429 9.99899308,8.97793995 C10.0045328,9.23547561 9.91048801,9.4852017 9.7364477,9.67510112 C9.5624074,9.86499054 9.3218008,9.98040411 9.06476511,9.99729317 C8.80773943,10.0141722 8.55410356,9.93122685 8.35672455,9.76572607 C8.35672455,9.76572607 8.33538907,9.74605717 8.29271811,9.70671936 L4.99972153,6.41472271 L1.70672494,9.70671936 C1.52448509,9.88875922 1.27902876,9.99346339 1.02149311,9.99899308 C0.763967449,10.0045328 0.514241358,9.91048801 0.324341935,9.7364477 C0.134452511,9.5624074 0.0190389396,9.3218008 0.00214988026,9.06476511 C-0.0147291796,8.80773943 0.0682162005,8.55410356 0.233716983,8.35672455 C0.233716983,8.35672455 0.253385887,8.33538907 0.292723696,8.29271811 L3.58472034,4.99972153 L0.292723696,1.70672494 C0.110683835,1.52448509 0.00597966695,1.27902876 0.000449974937,1.02149311 C-0.00508971651,0.763967449 0.0889550454,0.514241358 0.262995352,0.324341935 C0.437035658,0.134452511 0.677642257,0.0190389396 0.934677941,0.00214988026 C1.19170362,-0.0147291796 1.4453395,0.0682162005 1.6427185,0.233716983 C1.6427185,0.233716983 1.66405398,0.253385887 1.70672494,0.292723696 L1.70672494,0.292723696 Z" id="Vector"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import { CommonUtility } from '~/utils/utility';

export default {
    name: 'AppToast',
    data () {
        return {
            visible: false,
            msg: '',
            leftIconSrc: '',
            type: '',
            timer: null,
        };
    },
    methods: {
        show (msg, leftIconSrc, type, duration) {
            clearTimeout(this.timer);
            this.visible = true;
            this.type = type;
            this.msg = msg;
            this.leftIconSrc = leftIconSrc;

            this.timer = setTimeout(() => {
                this.visible = false;
                this.timer = null;
            }, duration);
        },
        cancle () {
            clearTimeout(this.timer);
            this.visible = false;
            this.timer = null;
        },
    },
};
</script>

<style scoped lang="scss">
.toast-container {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    position: fixed;
    z-index: 1100;
    top: 5%;
}

.toast {
    max-width: 90%;
    width: auto;
    padding: 10px 14px;
    background: rgba(0, 0, 0, 0.3);
    color: white;
    border-radius: 11px;
    font-size: 18px;
    font-weight: 400;

    transition: opacity 0.3s;
    display: flex;
    align-items: center
}

.toast.info {
    background: RGBA(234, 249, 219, 1);
    color: rgba(81, 162, 0, 1);
    svg g {
        fill: rgba(81, 162, 0, 1);
    }
}

.toast.warning {
    background: rgba(253, 227, 227, 1);
    color: rgba(255, 47, 37, 1);
    svg g {
        fill: rgba(255, 47, 37, 1);
    }
}

.toast.a {
    background: rgba(225, 236, 255, 1);
    color: rgba(5, 114, 248, 1);
    svg g {
        fill: rgba(5, 114, 248, 1);
    }
}

.toast.b {
    background: rgba(255, 246, 199, 1);
    color: rgba(248, 148, 5, 1);
    svg g {
        fill: rgba(248, 148, 5, 1)
    }
}

.left {
    min-width: 20px;
    min-height: 20px;
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.right {
    min-width: 10px;
    min-height: 10px;
    width: 10px;
    height: 10px;
    margin-left: 20px;
}
</style>
